import { UserGender } from 'domains/user'
import { toPhiGender } from 'domains/user/UserGender'
import { Nullable } from 'types/utility'

export const BOTH_WRITE_MODES = new Set([
  'DUAL_WRITE_AND_READ_FROM_DTX_MODE',
  'DUAL_WRITE_AND_READ_FROM_PHI_FALLBACK_MODE',
  'DUAL_WRITE_READ_ONLY_FROM_PHI_MODE',
])

export const PHI_ONLY_MODES = new Set(['PHI_ONLY_MODE'])

export type PhiPatientUpdateParams = {
  firstName?: string
  lastName?: string
  birthDate?: string
  gender?: UserGender | string
}

export type PhiPatientUpdateBody = {
  phiPatientId: Nullable<number>
  personFirstName?: string
  personLastName?: string
  personBirthDate?: string
  personGender?: string
}

export const buildPhiBody = (
  phiPatientId: Nullable<number>,
  { firstName, lastName, birthDate, gender }: PhiPatientUpdateParams,
): PhiPatientUpdateBody => ({
  phiPatientId,
  ...(firstName && { personFirstName: firstName }),
  ...(lastName && { personLastName: lastName }),
  ...(birthDate && { personBirthDate: birthDate }),
  ...(gender && { personGender: toPhiGender(gender) }),
})
